import { useState } from 'react';
import { Stack, Typography } from "@mui/material";
import { formatDate } from 'utils/formatDate';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';

const NotificationIcon = ({ type, read }) => {
    switch (type) {
        case 'MONTHLY REPORT':
            return (
                <Stack className='relative rounded-full bg-[#EEF1F8] p-2.5 items-center justify-center'>
                    {!read && (
                        <div className="absolute top-0.5 left-0.5 w-2 h-2 bg-[#146BDE] rounded-full" />
                    )}
                    <DescriptionOutlinedIcon className="w-6 h-6 text-[#556FB5]" />
                </Stack>
            );
        case 'CREATE_CLIENT_ADMIN':
        case 'CREATE_CLIENT':
        case 'CREATE_CLIENT_USER':
            return (
                <Stack className='relative rounded-full bg-[#EFF1F2] p-2.5 items-center justify-center'>
                    {!read && (
                        <div className="absolute top-0.5 left-0.5 w-2 h-2 bg-[#146BDE] rounded-full" />
                    )}
                    <EditOutlinedIcon className="w-6 h-6 text-[#556FB5]" />
                </Stack>
            )
        case 'UPDATE_CLIENT_ADMIN':
        case 'UPDATE_CLIENT':
        case 'UPDATE_CLIENT_USER':
            return (
                <Stack className='relative rounded-full bg-[#FFFBE6] p-2.5 items-center justify-center'>
                    {!read && (
                        <div className="absolute top-0.5 left-0.5 w-2 h-2 bg-[#146BDE] rounded-full" />
                    )}
                    <RefreshIcon className="w-6 h-6 text-[#FBD603]" />
                </Stack>
            )
        case 'DELETE_CLIENT_ADMIN':
        case 'DELETE_CLIENT':
        case 'DELETE_CLIENT_USER':
            return (
                <Stack className='relative rounded-full bg-[#FCEAED] p-2.5 items-center justify-center'>
                    {!read && (
                        <div className="absolute top-0.5 left-0.5 w-2 h-2 bg-[#146BDE] rounded-full" />
                    )}
                    <DeleteSweepOutlinedIcon className="w-6 h-6 text-[#E52A49]" />
                </Stack>
            )
        default:
            return <></>;
    }
};

const NotificationMessage = ({ metadata, type }) => {
    switch (type) {
        case 'MONTHLY REPORT':
            return (
                <Typography fontSize={14}>
                    Check your <a target='__blank' href={metadata.url} className='font-bold'>{metadata.object}</a> now.
                </Typography>
            );
        case 'CREATE_CLIENT':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    added client
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'CREATE_CLIENT_USER':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    added user
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'CREATE_CLIENT_ADMIN':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    added admin
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'UPDATE_CLIENT':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    updated client
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'UPDATE_CLIENT_USER':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    updated user
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'UPDATE_CLIENT_ADMIN':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    updated admin
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'DELETE_CLIENT':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    deleted client
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'DELETE_CLIENT_USER':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    deleted user
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        case 'DELETE_CLIENT_ADMIN':
            return (
                <Typography>
                    <Typography display='inline' fontWeight={600}>{metadata.actor} </Typography>
                    deleted admin
                    <Typography display='inline' fontWeight={600}> {metadata.target}.</Typography>
                </Typography>
            )
        default:
            return <></>;
    }
};

export const NotificationComponent = ({ notification, onReadNotification }) => {
    const [read, setRead] = useState(false);

    const handleClick = () => {
        if (!read) {
            setRead(true);
            onReadNotification();
        }
    };

    return (
        <Stack
            direction='row'
            className='px-4 py-4 gap-5 hover:bg-[#f2f6fd]'
            alignItems='center'
            onClick={handleClick}
        >
            <NotificationIcon type={notification.type} read={read} />
            <Stack spacing={1} justifyContent="center">
                <NotificationMessage metadata={notification.metadata} type={notification.type} />
                <Typography fontSize={12} color='#5F737F'>
                    {formatDate.toFullDateTimeWithMonthName(notification.created_at)}
                </Typography>
            </Stack>
        </Stack>
    );
};